module.exports = __webpack_public_path__ + "static/media/logo.358ba26c.png";